import { withInstall } from '../_util'

import Pagetable from './Pagetable'
import PagetableColumnIndex from './columns/PagetableColumnIndex'
import PagetableColumnString from './columns/PagetableColumnString'
import PagetableColumnLink from './columns/PagetableColumnLink'
import PagetableColumnNumber from './columns/PagetableColumnNumber'
import PagetableColumnDate from './columns/PagetableColumnDate'
import PagetableColumnSingleselect from './columns/PagetableColumnSingleselect'
import PagetableColumnMultiselect from './columns/PagetableColumnMultiselect'
import PagetableColumnButtongroup from './columns/PagetableColumnButtongroup'
import PagetableCellButton from './columns/PagetableCellButton'
import PagetableColumngroup from './columns/PagetableColumngroup'
import PagetableColumnDiy from './columns/PagetableColumnDiy'

export default withInstall<
  typeof Pagetable,
  {
    PagetableColumnIndex: typeof PagetableColumnIndex
    PagetableColumnString: typeof PagetableColumnString
    PagetableColumnLink: typeof PagetableColumnLink
    PagetableColumnNumber: typeof PagetableColumnNumber
    PagetableColumnDate: typeof PagetableColumnDate
    PagetableColumnSingleselect: typeof PagetableColumnSingleselect
    PagetableColumnMultiselect: typeof PagetableColumnMultiselect
    PagetableColumnButtongroup: typeof PagetableColumnButtongroup
    PagetableCellButton: typeof PagetableCellButton
    PagetableColumngroup: typeof PagetableColumngroup
    PagetableColumnDiy: typeof PagetableColumnDiy
  }
>(Pagetable, {
  PagetableColumnIndex,
  PagetableColumnString,
  PagetableColumnLink,
  PagetableColumnNumber,
  PagetableColumnDate,
  PagetableColumnSingleselect,
  PagetableColumnMultiselect,
  PagetableColumnButtongroup,
  PagetableCellButton,
  PagetableColumngroup,
  PagetableColumnDiy,
})

export * from './Pagetable'
export { default as usePagetable } from './hooks/usePagetable'
